import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  fadeOut() {
    this.element.classList.add("RandomDots--fade_out")
  }
}
